module.exports = __webpack_public_path__ + "img/search-recent.78b596df.svg";